import { render, staticRenderFns } from "./WelcomeBonusCard.vue?vue&type=template&id=4467a06b&scoped=true"
import script from "./WelcomeBonusCard.vue?vue&type=script&lang=js"
export * from "./WelcomeBonusCard.vue?vue&type=script&lang=js"
import style0 from "./WelcomeBonusCard.vue?vue&type=style&index=0&id=4467a06b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467a06b",
  null
  
)

export default component.exports